import { WidgetSize } from '../types'

// Минимальный размер ячейки
export const MIN_CELL_SIZE = 168

// Размеры виджетов в grid units (фиксированные)
export const WIDGET_DIMENSIONS = {
	[WidgetSize.SMALL]: { w: 1, h: 1 }, // 1x1
	[WidgetSize.MEDIUM]: { w: 2, h: 1 }, // 2x1
	[WidgetSize.LARGE]: { w: 2, h: 2 }, // 2x2
	[WidgetSize.FULL]: { w: -1, h: 2 }, // специальное значение для полной ширины
}

// Функция для получения размеров виджета по его size
export const getWidgetDimensions = (size: WidgetSize) => {
	return WIDGET_DIMENSIONS[size]
}

// Функция для вычисления количества колонок на основе доступной ширины
export const calculateColumns = (
	containerWidth: number,
	gapSize = 16,
): number => {
	if (containerWidth <= 0) return 1
	// Вычисляем максимальное количество колонок с минимальным размером ячейки
	const maxCols = Math.floor(
		(containerWidth + gapSize) / (MIN_CELL_SIZE + gapSize),
	)

	// Минимум 1 колонка, максимум 12 (для очень широких экранов)
	return Math.max(1, Math.min(maxCols, 12))
}

// Функция для вычисления оптимального размера ячейки
export const calculateOptimalCellSize = (
	containerWidth: number,
	gapSize = 16,
): number => {
	if (containerWidth <= 0) return MIN_CELL_SIZE

	const cols = calculateColumns(containerWidth, gapSize)
	const gapsWidth = (cols - 1) * gapSize
	const cellsWidth = containerWidth - gapsWidth

	// Вычисляем оптимальный размер ячейки
	const optimalSize = Math.floor(cellsWidth / cols)

	// Возвращаем минимум MIN_CELL_SIZE
	return Math.max(optimalSize, MIN_CELL_SIZE)
}
